import { useRef, useCallback } from 'react';

import { arrayMoveImmutable } from 'array-move';

export default function useListDragAndDrop({
  itemHeight,
  itemsGap,
  itemsList,
  onItemsOrderChange,
  listContainerRef,
}) {
  const ref = useRef();
  const currentRef = listContainerRef || ref;

  const dragListItem = (event, index) => {
    event.dataTransfer.setData('index', index);
  };

  const changeListItemOrder = useCallback(
    (event) => {
      event.preventDefault();
      const oldListItemIndex = event.dataTransfer.getData('index');

      const coords = currentRef.current.getBoundingClientRect();

      const yPosition = event.clientY - coords.top;

      const newListItemIndex = Math.max(
        Math.floor(yPosition / (itemHeight + itemsGap)),
        0
      );

      const newItemsList = arrayMoveImmutable(
        itemsList,
        oldListItemIndex,
        newListItemIndex
      );

      onItemsOrderChange(newItemsList);
    },
    [currentRef, itemHeight, itemsGap, itemsList, onItemsOrderChange]
  );

  const disableDragOver = (event) => event.preventDefault();

  return {
    dragListItem,
    disableDragOver,
    changeListItemOrder,
    listContainerRef: currentRef,
  };
}
